/* ===== dos hydrate — home page interactions (flavors, buy module, nutrition, FAQ, videos) ===== */
(function () {
  'use strict';

  var FLAVORS = [
    { name: 'Pink Lemonade', note: 'tart + bright', color: '#CB7D98', img: 'pack-pinklemonade-min.png', live: true, desc: 'A snap of fresh-squeezed lemon. Bright and citrusy with a clean, lightly sweet finish. No candy aftertaste, no neon dye.' },
    { name: 'Watermelon', note: 'juicy + light', color: '#E89191', img: 'pack-watermelon-min.png', live: false, desc: 'Ripe summer watermelon with a whisper of salt. Light on the palate and easy to drink all afternoon.' },
    { name: 'White Peach', note: 'soft + floral', color: '#F3AF96', img: 'pack-whitepeach-min.png', live: false, desc: 'Orchard white peach, gently floral and never syrupy. The mellowest of the six.' },
    { name: 'Blood Orange', note: 'deep + citrus', color: '#DB4D2E', img: 'pack-bloodorange-min.png', live: false, desc: 'Sicilian blood orange with a bitter-sweet edge. The most assertive citrus in the lineup.' },
    { name: 'Cucumber Lime', note: 'crisp + clean', color: '#C3D187', img: 'pack-cucumberlime-min.png', live: false, desc: 'Cold cucumber and fresh lime. Spa-clean and the best one over ice after heat or a sauna.' },
    { name: 'Strawberry Kiwi', note: 'ripe + tangy', color: '#5E8C3A', img: 'pack-strawberrykiwi-min.png', live: false, desc: 'Sweet strawberry against sharp kiwi. Fruit-forward without tipping into dessert.' },
    { name: 'Variety Pack', note: 'all six', color: '#171717', img: 'pack-pinklemonade-min.png', live: false, variety: true, desc: 'All six flavors, five sachets each. The easiest way to find your favorite before committing to a single box.' }
  ];
  window.DOS_FLAVORS = FLAVORS;
  var PRICES_FALLBACK = { sub: { 1: 28, 2: 48, 3: 67 }, once: { 1: 35, 2: 60, 3: 84 } };
  function packData(n) {
    var cfg = window.DOS_BUY || {};
    var list = cfg.packs || [];
    for (var i = 0; i < list.length; i++) { if (list[i].pack === n) return list[i]; }
    return null;
  }
  /* Everything is the single box now, so a pack price is unit x quantity less the
     automatic bundle discount configured in Shopify (14.29% at 2, 20% at 3).
     Keeping the percentages here means the displayed price matches what the cart
     actually charges. */
  var BUNDLE_OFF = { 1: 0, 2: 0.142857, 3: 0.20 };
  function unitDollars(plan) {
    var p = packData(1);
    if (p && p.variant) return (plan === 'sub' ? p.subCents : p.onceCents) / 100;
    return PRICES_FALLBACK[plan][1];
  }
  function priceDollars(n, plan) {
    var unit = unitDollars(plan);
    var off = BUNDLE_OFF[n] || 0;
    return Math.round(unit * n * (1 - off));
  }

  /* ---- flavors: swatch rail + featured showcase ---- */
  var featIdx = 0;
  var pill = document.querySelector('[data-feat-pill]');
  var nameEl = document.querySelector('[data-feat-name]');
  function setFeat(i) {
    featIdx = i;
    var f = FLAVORS[i];
    var badge = document.querySelector('[data-feat-badge]');
    if (badge) {
      badge.textContent = f.live ? 'In stock' : 'Ships next week';
      badge.style.background = f.live ? '#D6E594' : 'rgba(23,23,23,0.08)';
      badge.style.color = '#171717';
    }
    var noteEl = document.querySelector('[data-feat-note]');
    if (noteEl) noteEl.textContent = f.note;
    /* swap the capsule art: derive the asset base from the current src so this
       works in the theme (Shopify CDN) and the compiled demo alike */
    if (f.img) {
      var swap = function (im, file) {
        var cur = im.getAttribute('src') || '';
        var base = cur.replace(/pack-[a-z-]+\.png.*$/, '');
        if (base !== cur) im.setAttribute('src', base + file);
      };
      /* front sachet follows the pick */
      document.querySelectorAll('[data-buy-pack-desktop],[data-buy-pack-mobile],[data-flavor-art]').forEach(function (im) {
        swap(im, f.img);
      });
      /* the stacked sachets behind it (2- and 3-pack): a variety pack shows a
         different flavour per layer, a single flavour shows its own colour */
      var singles = FLAVORS.filter(function (x) { return !x.variety; });
      document.querySelectorAll('[data-buy-stack]').forEach(function (im) {
        var layer = Number(im.getAttribute('data-buy-stack')) || 2;
        if (f.variety) swap(im, singles[(layer - 1) % singles.length].img);
        else swap(im, f.img);
      });
    }
    if (pill) { pill.textContent = f.note; pill.style.background = f.color + '26'; }
    if (nameEl) nameEl.textContent = f.name;
    document.querySelectorAll('[data-flavor-swatch]').forEach(function (b) {
      var on = Number(b.getAttribute('data-flavor-swatch')) === i;
      b.style.borderColor = on ? '#171717' : 'rgba(23,23,23,0.08)';
      b.style.boxShadow = on ? '0 10px 22px rgba(23,23,23,0.10)' : 'none';
      b.style.transform = on ? 'translateY(-2px)' : 'none';
    });
  }
  document.querySelectorAll('[data-flavor-swatch]').forEach(function (b) {
    var i = Number(b.getAttribute('data-flavor-swatch'));
    b.addEventListener('click', function () { setFeat(i); });
  });

  /* ---- buy module ---- */
  var state = { plan: 'sub', pack: 1 };
  var checkoutBtn = document.querySelector('[data-buy-checkout]');
  function money(n) { return '$' + n; }
  function render() {
    var isSub = state.plan === 'sub';
    document.querySelectorAll('[data-buy-plan]').forEach(function (b) {
      var on = b.getAttribute('data-buy-plan') === state.plan;
      b.style.background = on ? '#171717' : 'transparent';
      b.style.color = on ? '#F8F8F8' : '#171717';
      b.style.opacity = on ? '1' : '0.6';
    });
    [1, 2, 3].forEach(function (n) {
      var btn = document.querySelector('[data-buy-pack="' + n + '"]');
      if (!btn) return;
      var on = n === state.pack;
      /* selected pack: real accent border + tint + ring, so the choice is unmistakable */
      var AC = '#D6E594';
      btn.style.boxShadow = on ? ('0 0 0 3px ' + AC + '4D, inset 3px 3px 8px rgba(23,23,23,0.05)') : '6px 6px 14px #E8E8E8,-6px -6px 14px #FFFFFF';
      btn.style.border = on ? ('2.5px solid ' + AC) : '2px solid rgba(23,23,23,0.08)';
      btn.style.background = on ? (AC + '1F') : '#FFFFFF';
      var priceEl = document.querySelector('[data-pack-price="' + n + '"]');
      if (priceEl) priceEl.textContent = money(priceDollars(n, state.plan));
    });
    var servings = state.pack * 30;
    var sEl = document.querySelector('[data-buy-servings]');
    if (sEl) sEl.textContent = String(servings);
    var mEl = document.querySelector('[data-buy-mult]');
    if (mEl) mEl.textContent = '×' + servings;
    var cEl = document.querySelector('[data-buy-count]');
    if (cEl) cEl.textContent = state.pack + (state.pack === 1 ? ' pack' : ' packs');
    document.querySelectorAll('[data-buy-stack]').forEach(function (img) {
      img.style.display = state.pack >= Number(img.getAttribute('data-buy-stack')) ? 'block' : 'none';
    });
    var shift = state.pack >= 3 ? -21 : state.pack >= 2 ? -11 : 0;
    document.querySelectorAll('[data-buy-pack-img]').forEach(function (im) {
      im.style.transform = 'translateX(' + shift + 'px) scale(0.6)';
    });
    var st2 = document.querySelector('[data-buy-stack="2"]');
    if (st2) st2.style.transform = 'translateX(' + (state.pack >= 3 ? -21 : -11) + 'px) translateX(-50%) scale(0.6) translate(15%,0)';
    var gift = document.querySelector('[data-buy-gift]');
    if (gift) gift.style.opacity = isSub ? '1' : '0.25';
    /* write the LABEL span, not the button: the button also holds the
       [data-delivery-est] arrives line, which textContent would destroy */
    if (checkoutBtn) {
      var lbl = checkoutBtn.querySelector('[data-buy-cta-label]');
      if (lbl) lbl.textContent = 'Add to cart'; else checkoutBtn.textContent = 'Add to cart';
    }
    var segShopLbl = document.querySelector('[data-pill-shop] span');
    if (segShopLbl) segShopLbl.textContent = 'Add · ' + money(priceDollars(state.pack, state.plan));
    /* savings badge: buying N single packs vs the N-pack price, for the active plan */
    for (var sv = 2; sv <= 3; sv++) {
      var svEl = document.querySelector('[data-pack-save="' + sv + '"]');
      if (!svEl) continue;
      var one = priceDollars(1, state.plan), many = priceDollars(sv, state.plan);
      var diff = Math.round(one * sv - many);
      svEl.textContent = diff > 0 ? 'Save $' + diff : '';
      svEl.style.display = diff > 0 ? '' : 'none';
    }
  }
  document.querySelectorAll('[data-buy-plan]').forEach(function (b) {
    b.addEventListener('click', function () { state.plan = b.getAttribute('data-buy-plan'); render(); });
  });
  document.querySelectorAll('[data-buy-pack]').forEach(function (b) {
    b.addEventListener('click', function () { state.pack = Number(b.getAttribute('data-buy-pack')); render(); });
  });
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () {
    var p = packData(state.pack);
    if (!p || !p.variant) {
      alert('Almost there: set the 1/2/3-pack products in Theme settings → dos — Store.');
      return;
    }
    checkoutBtn.disabled = true;
    var lblAdding = checkoutBtn.querySelector('[data-buy-cta-label]');
    if (lblAdding) lblAdding.textContent = 'Adding…'; else checkoutBtn.textContent = 'Adding…';
    var isSub = state.plan === 'sub' && p.sellingPlan;
    var cfg0 = window.DOS_BUY || {};
    var fp = window.dosFlavorPicks ? window.dosFlavorPicks() : [];
    /* One product, six flavour variants. Pack size is expressed as QUANTITY of the
       single box, never a separate 2-pack/3-pack product: 60 servings = qty 2,
       90 = qty 3. Repeats of one flavour collapse into a single line with that
       quantity; distinct flavours each get their own line. */
    var perBox = (cfg0.packs || []).filter(function (x) { return x.n === 1; })[0] || p;
    var planId = (window.dosSellingPlan && window.dosSellingPlan()) || perBox.sellingPlan;
    var baseId = (isSub && perBox.subVariant) ? perBox.subVariant : perBox.variant;

    function variantFor(name) {
      /* DOS_FLAVOR_VARIANTS maps a flavour name to its variant id (and optional
         subVariant). Until those ids exist the single-box variant is used, so the
         flavour still rides along as a line property. */
      var map = window.DOS_FLAVOR_VARIANTS || {};
      if (!name) return baseId;
      var want = String(name).toLowerCase().replace(/[^a-z]+/g, '');
      var e = null;
      for (var k in map) {
        if (String(k).toLowerCase().replace(/[^a-z]+/g, '') === want) { e = map[k]; break; }
      }
      if (!e) return baseId;
      return (isSub && e.subVariant) ? e.subVariant : (e.variant || baseId);
    }

    function planFor(nm) {
      var map = window.DOS_FLAVOR_VARIANTS || {};
      if (!nm) return null;
      var want = String(nm).toLowerCase().replace(/[^a-z]+/g, '');
      for (var k in map) {
        if (String(k).toLowerCase().replace(/[^a-z]+/g, '') === want) return map[k].sellingPlan || null;
      }
      return null;
    }

    var qty = Number(state.pack) || 1;
    var lines;
    if (fp.length) {
      var order = [], byKey = {};
      fp.forEach(function (nm) {
        var id = variantFor(nm);
        var key = id + '|' + nm;
        if (byKey[key]) { byKey[key].quantity += 1; return; }
        var li = { id: id, quantity: 1, properties: { 'Flavor': nm } };
        /* each variant carries its OWN selling plan: applying pack 1's plan to a
           flavour Skio hasn't attached it to makes Shopify reject the add with
           "Cannot apply selling plan to variant" */
        var vPlan = planFor(nm);
        if (isSub && vPlan) li.selling_plan = vPlan;
        byKey[key] = li;
        order.push(li);
      });
      lines = order;
    } else {
      var item = { id: baseId, quantity: qty };
      if (isSub && planId) item.selling_plan = planId;
      lines = [item];
    }
    var cfg = window.DOS_BUY || {};
    var gift = cfg.gift;
    /* subscriptions get the insulated bottle free — add it alongside, once */
    var giftCheck = (isSub && gift && gift.variant && gift.available)
      ? fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var has = (cart.items || []).some(function (it) { return it.id === gift.variant; });
          return has ? null : { id: gift.variant, quantity: 1, properties: { '_dos_free_gift': 'true' } };
        }).catch(function () { return null; })
      : Promise.resolve(null);
    function isGiftLine(it) {
      var p = it && it.properties;
      return !!(p && (p._dos_free_gift || p['_dos_free_gift']));
    }

    function postItems(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      });
    }
    giftCheck.then(function (giftItem) {
      var items = giftItem ? lines.concat([giftItem]) : lines.slice();
      /* /cart/add.js INCREMENTS, so pressing Add twice on a 3-pack left 6 boxes
         in the cart. Zero out this product's existing flavour lines first, so the
         cart always ends up holding exactly the pack size that was chosen. */
      var ourVariants = {};
      Object.keys(window.DOS_FLAVOR_VARIANTS || {}).forEach(function (k) {
        var e = (window.DOS_FLAVOR_VARIANTS || {})[k];
        if (e && e.variant) ourVariants[e.variant] = true;
        if (e && e.subVariant) ourVariants[e.subVariant] = true;
      });
      if (baseId) ourVariants[baseId] = true;
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        /* remove by LINE, highest first: several lines can share a variant (one
           per flavour), which makes an updates-by-variant call ambiguous */
        var doomed = [];
        (cart.items || []).forEach(function (it, i) {
          if (ourVariants[it.id] && !isGiftLine(it)) doomed.push(i + 1);
        });
        doomed.sort(function (a, b) { return b - a; });
        var chain = Promise.resolve();
        doomed.forEach(function (ln) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: ln, quantity: 0 })
            }).catch(function () { return null; });
          });
        });
        return chain;
      }).catch(function () { return null; })
      .then(function () { return postItems(items); })
      .then(function (res) {
        /* Shopify rejects the whole request if ANY line's selling plan isn't
           attached to that variant. Rather than showing the customer a raw
           "Cannot apply selling plan to variant" dialog, drop the offending
           plans and retry so the order still goes through. */
        var msg = String((res.data && (res.data.description || res.data.message)) || '');
        if (res.ok || !/selling plan/i.test(msg)) return res;
        var retried = items.map(function (it) {
          var c = {};
          for (var k in it) if (k !== 'selling_plan') c[k] = it[k];
          return c;
        });
        return postItems(retried);
      });
    }).then(function (res) {
      if (!res.ok) {
        checkoutBtn.disabled = false;
        render();
        alert((res.data && res.data.description) || 'Sorry, that option could not be added to the cart. Please check the product is available for one-time purchase.');
        return;
      }
      if (window.dosCart) {
        checkoutBtn.disabled = false;
        render();
        window.dosCart.open();
      } else {
        window.location.href = (window.DOS && window.DOS.cartUrl) || '/cart';
      }
    }).catch(function () {
      checkoutBtn.disabled = false;
      render();
      alert('Something went wrong adding to cart. Please try again.');
    });
  });
  render();

  /* ---- nutrition facts: flavor carousel + collapse ---- */
  var nutIdx = 0;
  function renderNut() {
    var f = FLAVORS[nutIdx];
    var el;
    if ((el = document.querySelector('[data-nut-index]'))) el.textContent = (nutIdx + 1) + ' of ' + FLAVORS.length;
    if ((el = document.querySelector('[data-nut-name]'))) el.textContent = f.name;
    if ((el = document.querySelector('[data-nut-swatch]'))) el.style.background = f.color;
    if ((el = document.querySelector('[data-nut-ingredients]'))) el.textContent = 'Pink Himalayan salt, Potassium, Magnesium, Vit B6, Vit B12, Coconut Water powder, Citric acid, Organic Stevia, Natural ' + f.name + ' Flavor, Beet juice powder.';
    document.querySelectorAll('[data-nut-dot]').forEach(function (d) {
      var on = Number(d.getAttribute('data-nut-dot')) === nutIdx;
      d.style.opacity = on ? '1' : '0.35';
      d.style.boxShadow = on ? '0 0 0 2px #fff,0 0 0 3.5px #171717' : 'none';
    });
  }
  var prev = document.querySelector('[data-nut-prev]');
  var next = document.querySelector('[data-nut-next]');
  if (prev) prev.addEventListener('click', function () { nutIdx = (nutIdx + FLAVORS.length - 1) % FLAVORS.length; renderNut(); });
  if (next) next.addEventListener('click', function () { nutIdx = (nutIdx + 1) % FLAVORS.length; renderNut(); });
  document.querySelectorAll('[data-nut-dot]').forEach(function (d) {
    d.addEventListener('click', function () { nutIdx = Number(d.getAttribute('data-nut-dot')); renderNut(); });
  });
  var nutToggle = document.querySelector('[data-nut-toggle]');
  var nutBody = document.querySelector('[data-nut-body]');
  var nutChev = document.querySelector('[data-nut-chev]');
  /* supplement facts stay expanded at all times */
  if (nutBody) nutBody.style.display = 'block';
  if (nutChev) nutChev.style.transform = 'rotate(180deg)';

  /* ---- FAQ ---- */
  document.querySelectorAll('[data-home-faq]').forEach(function (item) {
    item.addEventListener('click', function () {
      var a = item.querySelector('[data-faq-a]');
      var sign = item.querySelector('[data-faq-sign]');
      if (!a) return;
      var open = a.style.display !== 'none';
      a.style.display = open ? 'none' : 'block';
      if (sign) sign.textContent = open ? '+' : '−';
    });
  });

  /* ---- UGC videos ---- */
  function fmt(t) {
    if (!isFinite(t)) return '0:00';
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  document.querySelectorAll('[data-ugc-video-frame]').forEach(function (frame) {
    var video = frame.querySelector('[data-ugc-video]');
    var playBtn = frame.querySelector('[data-ugc-play]');
    var muteBtn = frame.querySelector('[data-ugc-mute]');
    var slider = frame.querySelector('[data-ugc-slider]');
    var time = frame.querySelector('[data-ugc-time]');
    var iPlay = frame.querySelector('[data-ugc-icon-play]');
    var iPause = frame.querySelector('[data-ugc-icon-pause]');
    var iMuted = frame.querySelector('[data-ugc-icon-muted]');
    var iSound = frame.querySelector('[data-ugc-icon-sound]');
    if (!video) return;
    var userMuted = false; /* true only after the customer taps mute */
    function syncMuteIcons() {
      if (iMuted) iMuted.style.display = video.muted ? 'block' : 'none';
      if (iSound) iSound.style.display = video.muted ? 'none' : 'block';
    }
    function toggle() { if (video.paused) video.play(); else video.pause(); }
    if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    /* click anywhere on the video toggles playback */
    video.style.cursor = 'pointer';
    video.addEventListener('click', toggle);
    video.addEventListener('play', function () {
      if (iPlay) iPlay.style.display = 'none';
      if (iPause) iPause.style.display = 'block';
      /* play with sound unless the customer has explicitly muted this clip */
      if (!userMuted && video.muted) { video.muted = false; syncMuteIcons(); }
    });
    video.addEventListener('pause', function () { if (iPlay) iPlay.style.display = 'block'; if (iPause) iPause.style.display = 'none'; });
    if (muteBtn) muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      userMuted = video.muted;
      syncMuteIcons();
    });
    video.addEventListener('timeupdate', function () {
      if (video.duration) if (slider) slider.value = String(Math.round(video.currentTime / video.duration * 1000));
      if (time) time.textContent = fmt(video.currentTime) + ' / ' + fmt(video.duration || 0);
    });
    if (slider) slider.addEventListener('input', function () {
      if (video.duration) video.currentTime = Number(slider.value) / 1000 * video.duration;
    });
  });

  /* ---- sticky FABs: reveal after scrolling past the hero ---- */
  (function () {
    var shop = document.querySelector('[data-shop-fab]');
    var promo = document.querySelector('[data-promo-fab]');
    var hero = document.querySelector('[data-hero-sect]');
    if (!shop && !promo) return;
    function upd() {
      var past = hero ? (hero.getBoundingClientRect().bottom < 90) : (window.scrollY > 500);
      [shop, promo].forEach(function (b) {
        if (!b) return;
        b.style.opacity = past ? '1' : '0';
        b.style.pointerEvents = past ? 'auto' : 'none';
        b.style.transform = past ? 'translateY(-100%)' : 'translateY(calc(-100% + 18px))';
      });
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    if (promo) promo.addEventListener('click', function () { if (window.dosOpenPromo) window.dosOpenPromo(); });
    upd();
  })();
})();





/* ===== one clip at a time: starting a video pauses every other one ===== */
(function dosSoloPlay() {
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || !v.hasAttribute('data-ugc-video')) return;
    document.querySelectorAll('video[data-ugc-video]').forEach(function (o) {
      if (o !== v && !o.paused) o.pause();
    });
  }, true);
})();



/* ===== See it in action: one index drives position, scale, counter and playback ===== */
(function dosUgcCarousel() {
  var stage = document.querySelector('[data-ugc-stage]');
  if (!stage) return;
  var slides = [].slice.call(stage.querySelectorAll('[data-ugc-slide]'));
  if (!slides.length) return;
  var n = slides.length, idx = 0;
  var BASE = 'border-radius:28px;overflow:hidden;background:transparent;display:flex;align-items:center;justify-content:center;transition:transform .3s ease,opacity .3s ease';
  function delta(k) { var d = k - idx; if (d > n/2) d -= n; if (d < -n/2) d += n; return d; }
  function paint() {
    if (getComputedStyle(stage).overflow === 'visible') { slides.forEach(function (s) { s.removeAttribute('style'); }); return; }
    slides.forEach(function (s, k) {
      var d = delta(k);
      if (d === 0) s.style.cssText = 'position:relative;width:74%;max-width:420px;aspect-ratio:9/16;z-index:3;opacity:1;pointer-events:auto;' + BASE;
      else s.style.cssText = 'position:absolute;top:0;left:50%;height:100%;width:74%;max-width:420px;pointer-events:none;transform:translateX(calc(-50% + ' + (d*94) + '%)) scale(0.82);' + (Math.abs(d)===1 ? 'opacity:0.5;z-index:2;' : 'opacity:0;z-index:1;') + BASE;
    });
    var c = document.querySelector('[data-ugc-counter]');
    if (c) c.textContent = (idx + 1) + ' / ' + n;
    /* buffer the centred video so the first tap plays immediately */
    var av = slides[idx].querySelector('video[data-ugc-video]');
    if (av && !av._dosPrimed) {
      av._dosPrimed = true;
      av.preload = 'auto';
      if (av.paused && !av.currentTime) { try { av.load(); } catch (e) {} }
    }
  }
  function go(dir) {
    document.querySelectorAll('video[data-ugc-video]').forEach(function (v) { if (!v.paused) v.pause(); });
    idx = ((idx + dir) % n + n) % n;
    paint();
  }
  var p = document.querySelector('[data-ugc-prev]');
  var nx = document.querySelector('[data-ugc-next]');
  if (p) p.addEventListener('click', function () { go(-1); });
  if (nx) nx.addEventListener('click', function () { go(1); });
  var tx = null;
  stage.addEventListener('touchstart', function (e) { tx = e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (tx == null) return;
    var end = e.changedTouches[0] ? e.changedTouches[0].clientX : null;
    if (end != null && Math.abs(end - tx) > 40) go(end < tx ? 1 : -1);
    tx = null;
  }, { passive: true });
  paint();
  window.addEventListener('resize', paint);
})();

/* ===== emit AddToCart where the action happens (feeds dos-track.js fan-out) ===== */
(function dosAddToCartMeasure() {
  document.addEventListener('click', function (e) {
    var cta = e.target && e.target.closest && e.target.closest('[data-buy-checkout]');
    if (!cta || !window.dosTrack) return;
    var d = window.DOS_PRODUCT || {};
    window.dosTrack('AddToCart', {
      content_ids: (d.ids || []).map(String),
      content_name: d.name,
      value: d.value,
      currency: d.currency || 'USD'
    });
  });
})();

/* ===== Build your box =====
   Tap a flavour card to add one sachet-box to the pack; tap again for two of the
   same. A progress bar shows n of N chosen, and the CTA stays locked until the
   box is full. Exposes the same hooks the cart path already reads. */
(function dosFlavorSlots() {
  var picker = document.querySelector('[data-flavor-picker]');
  if (!picker || typeof window.DOS_FLAVORS === 'undefined') return;
  var F = window.DOS_FLAVORS;
  var packCount = 1, counts = {}, order = [];
  var cards = picker.querySelectorAll('[data-flavor-card]');
  var bar = picker.querySelector('[data-flavor-bar]');
  var prog = picker.querySelector('[data-flavor-progress]');
  var nameEl = picker.querySelector('[data-feat-name]');
  var badge = picker.querySelector('[data-feat-badge]');
  var cta = document.querySelector('[data-buy-checkout]');
  var ctaLabel = cta && cta.querySelector('[data-buy-cta-label]');

  function total() { var n = 0; for (var k in counts) n += counts[k]; return n; }
  function picks() {
    var arr = [];
    order.forEach(function (i) { for (var n = 0; n < (counts[i] || 0); n++) arr.push(i); });
    return arr;
  }
  function swap(im, file) {
    var cur = im.getAttribute('src') || '';
    var base = cur.replace(/pack-[a-z-]+\.png.*$/, '');
    if (base !== cur && file) im.setAttribute('src', base + file);
  }
  function renderArt() {
    var p = picks();
    var front = p.length ? p[0] : 0;
    document.querySelectorAll('[data-buy-pack-desktop],[data-buy-pack-mobile],[data-flavor-art]').forEach(function (im) { swap(im, F[front] && F[front].img); });
    document.querySelectorAll('[data-buy-stack]').forEach(function (im) {
      var layer = Number(im.getAttribute('data-buy-stack')) || 2;
      var idx = p[layer - 1]; if (idx == null) idx = front;
      swap(im, F[idx] && F[idx].img);
    });
    if (nameEl) nameEl.textContent = F[front] ? F[front].name : '';
    if (badge) {
      var allLive = p.every(function (i) { return F[i] && F[i].live !== false; });
      badge.textContent = allLive ? 'In stock' : 'Ships next week';
      badge.style.background = allLive ? '#D6E594' : 'rgba(23,23,23,0.08)';
    }
  }
  function render() {
    var n = total(), full = n >= packCount;
    cards.forEach(function (b) {
      var i = Number(b.getAttribute('data-flavor-card'));
      var f = F[i]; if (!f) return;
      var c = counts[i] || 0;
      var tint = f.variety ? 'rgba(23,23,23,0.06)' : f.color + '22';
      var ring = f.variety ? '#171717' : f.color;
      b.style.background = c ? tint : '#fff';
      b.style.borderColor = c ? ring : 'rgba(23,23,23,0.1)';
      b.style.opacity = (!c && full) ? '0.4' : '1';
      var badgeEl = b.querySelector('[data-flavor-count]');
      if (badgeEl) {
        /* single pack: no badge needed. multi: the slot number this flavour holds
           (1, 2, 3 in the order picked), with "x2" when the same flavour fills two */
        var pos = order.indexOf(i);
        var label = c > 1 ? (pos + 1) + ' \u00d7' + c : String(pos + 1);
        badgeEl.textContent = label;
        badgeEl.style.display = (c && packCount > 1) ? 'flex' : 'none';
      }
    });
    if (bar) { bar.style.width = Math.min(100, (n / packCount) * 100) + '%'; bar.style.background = full ? '#D6E594' : '#171717'; }
    if (prog) prog.textContent = full ? 'Box full · ready to add' : n + ' of ' + packCount + ' chosen';
    if (cta) {
      cta.disabled = !full;
      cta.style.opacity = full ? '' : '0.55';
      cta.style.cursor = full ? 'pointer' : 'not-allowed';
      if (ctaLabel) ctaLabel.textContent = full ? 'Add to cart' : 'Pick ' + (packCount - n) + ' more';
    }
    renderArt();
  }
  function setPack(n) {
    packCount = n;
    /* keep what fits, drop the rest */
    while (total() > n) {
      var last = order[order.length - 1];
      remove(last);
    }
    render();
  }
  function add(i) {
    counts[i] = (counts[i] || 0) + 1;
    if (order.indexOf(i) === -1) order.push(i);
  }
  function remove(i) {
    if (!counts[i]) return;
    counts[i] -= 1;
    if (!counts[i]) { delete counts[i]; order = order.filter(function (x) { return x !== i; }); }
  }
  cards.forEach(function (b) {
    b.addEventListener('click', function () {
      var i = Number(b.getAttribute('data-flavor-card'));
      if (packCount === 1) {
        /* one box: tapping a flavour simply swaps to it */
        counts = {}; order = [];
        add(i);
      } else if (total() >= packCount) {
        remove(i);
      } else {
        add(i);
      }
      render();
    });
  });
  var clear = picker.querySelector('[data-flavor-clear]');
  if (clear) clear.addEventListener('click', function () { counts = {}; order = []; render(); });
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('[data-buy-pack]');
    if (!p) return;
    var want = Number(p.getAttribute('data-buy-pack')) || 1;
    setPack(want);
    setTimeout(function () { setPack(want); }, 0);
  });
  /* the cart path reads this */
  window.dosFlavorPicks = function () {
    return picks().map(function (i) { return F[i] ? F[i].name : null; }).filter(Boolean);
  };
  /* start with Pink Lemonade in a single box so the page never looks empty */
  counts = { 0: 1 }; order = [0];
  render();
})();

/* ===== Skio delivery frequency =====
   Skio owns the selling plans; the theme reads them straight off the product via
   selling_plan_groups. If a pack exposes more than one plan we surface a chooser,
   and the chosen plan id is what goes to /cart/add.js as selling_plan. With a
   single monthly plan the row stays hidden and nothing changes. */
(function dosSubFrequency() {
  var wrap = document.querySelector('[data-sub-freq]');
  var opts = document.querySelector('[data-sub-freq-opts]');
  if (!wrap || !opts) return;
  var chosen = {};   // pack number -> plan id

  function packNow() {
    var on = document.querySelector('[data-buy-pack].is-active') ||
             document.querySelector('[data-buy-pack][aria-pressed="true"]');
    if (on) return Number(on.getAttribute('data-buy-pack')) || 1;
    var found = 1;
    document.querySelectorAll('[data-buy-pack]').forEach(function (b) {
      if (getComputedStyle(b).borderColor.replace(/\s/g, '') === 'rgb(214,229,148)') {
        found = Number(b.getAttribute('data-buy-pack')) || found;
      }
    });
    return found;
  }
  function isSub() {
    var b = document.querySelector('[data-buy-plan="sub"]');
    if (!b) return false;
    var bg = getComputedStyle(b).backgroundColor.replace(/\s/g, '');
    return bg === 'rgb(23,23,23)' || bg === 'rgb(214,229,148)';
  }
  function plansFor(n) {
    var cfg = window.DOS_BUY || {};
    var p = (cfg.packs || []).filter(function (x) { return x.n === n || x.pack === n; })[0];
    var all = (p && p.plans) || [];
    /* the same interval can appear more than once (one plan per product/group);
       collapse duplicates so "Monthly · $28" is never offered twice */
    var seen = {}, uniq = [];
    all.forEach(function (pl) {
      var k = String(pl.name).toLowerCase().trim() + '|' + pl.cents;
      if (seen[k]) return;
      seen[k] = true;
      uniq.push(pl);
    });
    return uniq;
  }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  function render() {
    var n = packNow();
    var plans = plansFor(n);
    if (!isSub() || plans.length < 2) { wrap.style.display = 'none'; return; }
    wrap.style.display = 'block';
    if (!chosen[n]) chosen[n] = plans[0].id;
    opts.innerHTML = '';
    plans.forEach(function (pl) {
      var on = chosen[n] === pl.id;
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-sub-freq-opt', String(pl.id));
      b.style.cssText = 'cursor:pointer;font-family:inherit;font-size:11px;font-weight:900;letter-spacing:0.03em;padding:9px 14px;border-radius:100px;background:' +
        (on ? '#171717' : '#fff') + ';color:' + (on ? '#F8F8F8' : '#171717') +
        ';border:2px solid ' + (on ? '#171717' : 'rgba(23,23,23,0.12)');
      b.textContent = pl.name + (pl.cents ? ' · ' + money(pl.cents) : '');
      b.addEventListener('click', function () { chosen[n] = pl.id; render(); });
      opts.appendChild(b);
    });
  }

  /* the add-to-cart path asks for the active plan */
  window.dosSellingPlan = function () {
    var n = packNow();
    var plans = plansFor(n);
    if (!plans.length) return null;
    return chosen[n] || plans[0].id;
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-buy-pack]') || e.target.closest('[data-buy-plan]')) {
      setTimeout(render, 0);
    }
  });
  render();
})();

/* ===== flavour availability =====
   DOS_FLAVOR_VARIANTS carries each variant's available flag. A sold-out flavour
   is dimmed and blocked, so customers never hit the raw Shopify "already sold
   out" dialog. Tick "Continue selling when out of stock" in Shopify to make a
   pre-order flavour selectable again. */
(function dosFlavorStock() {
  function entry(name) {
    var map = window.DOS_FLAVOR_VARIANTS || {};
    if (!name) return null;
    var want = String(name).toLowerCase().replace(/[^a-z]+/g, "");
    for (var k in map) {
      if (String(k).toLowerCase().replace(/[^a-z]+/g, "") === want) return map[k];
    }
    return null;
  }
  function flavorMeta(name) {
    var list = window.DOS_FLAVORS || [];
    if (!name) return null;
    var want = String(name).toLowerCase().replace(/[^a-z]+/g, "");
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].name).toLowerCase().replace(/[^a-z]+/g, "") === want) return list[i];
    }
    return null;
  }
  /* every flavour stays selectable: Pink Lemonade ships now, the rest are
     pre-orders that ship next week */
  window.dosFlavorAvailable = function () { return true; };
  window.dosFlavorLive = function (name) {
    var m = flavorMeta(name);
    return m ? m.live !== false : true;
  };
  function paint() {
    var list = window.DOS_FLAVORS || [];
    document.querySelectorAll("[data-flavor-card]").forEach(function (b) {
      var f = list[Number(b.getAttribute("data-flavor-card"))];
      if (!f) return;
      var live = window.dosFlavorLive(f.name);
      b.style.opacity = "";
      b.style.cursor = "pointer";
      b.setAttribute("title", f.name + (live ? "" : " - ships next week"));
      b.setAttribute("data-flavor-soldout", "");
    });
  }
  function guard() {
    var nameEl = document.querySelector("[data-feat-name]");
    var badge = document.querySelector("[data-feat-badge]");
    if (!nameEl || !badge) return;
    var live = window.dosFlavorLive(nameEl.textContent.trim());
    badge.textContent = live ? "In stock" : "Ships next week";
    badge.style.background = live ? "#D6E594" : "rgba(23,23,23,0.08)";
    badge.style.color = "#171717";
  }
  document.addEventListener("click", function (e) {
    var sw = e.target.closest && e.target.closest("[data-flavor-card]");
    if (sw && sw.getAttribute("data-flavor-soldout") === "1") {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (sw) setTimeout(guard, 0);
  }, true);
  paint();
  setTimeout(paint, 400);
})();
